import React from "react";
import { Link } from "react-router";

/**
 * 
 * @param {object} param0
 * @param {string|undefined} param0.to
 * @param {React.ReactNode} param0.children 
 * @param {string|undefined} param0.className
 * @param {function|undefined} param0.onClick
 * @returns {React.ReactNode}
 */
export default function StyledLink({ to, onClick, children, className }) {
   return (
      <Link to={to} onClick={onclick} className={`${className} text-blue-500 underline`}>
         {children}
      </Link>
   );
}